// Package imports:
import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
// Component imports:
import Input from '../../ui-elements/Input/Formik/Input';
import Button from '../../ui-elements/Button/Button';
import Alert from '../../ui-elements/Alert/Alert';
// Service imports:
import { GET_PASSWORD_RESET_URL } from '../../services/config';
import { ErrorMessages } from '../../services/errorMessages';

interface IFormProps {
    values: IFormValues
}
interface IFormValues {
    email: string,
}


const LostPasswordForm: React.FC = () => {
    const [ response, setResponse ] = useState<JSX.Element>();

    const handleSubmit = async (values: IFormValues) => {
        try {
            const requestQuery = ({
                username: values.email,
            });
            const url = GET_PASSWORD_RESET_URL();
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestQuery)
            });
            
            if (response.ok) {
                const responseBody = await response.text();
            
                if (responseBody.includes('<h1>Error</h1>')) {
                    setResponse(
                        <Alert
                            closeAlert={() => setResponse(<></>)}
                            withCloseIcon
                            type="error"
                            headText='Villa kom upp.'
                            text={<>
                                    <span>Vinsamlegast reynið aftur eða hafið samband við </span>
                                    <a href='mailto:info@keldan.is'>info@keldan.is</a>
                                </>}
                        />
                    );
                } else {
                    setResponse(
                        <Alert 
                            closeAlert={() => setResponse(<></>)}
                            withCloseIcon
                            type="success"
                            headText={'Tölvupóstur hefur verið sendur á netfangið ' + values.email}
                        />
                    );
                }
            } else {
                setResponse(
                    <Alert 
                        closeAlert={() => setResponse(<></>)}
                        withCloseIcon
                        type="error"
                        headText={ErrorMessages.RequestFailed}
                    />);
            }
        } catch (e) {
            setResponse(
                <Alert
                    closeAlert={() => setResponse(<></>)}
                    withCloseIcon
                    type="error"
                    headText={ErrorMessages.NetworkError}
                />);
        }
    }

    const FormComponent: React.FC<IFormProps> = ({
        values
    }) => (
        <Form >
            <div className="form__section">
                <div className="form__body">
                    <div className="form__row">
                        <div className="form__col">
                            <Input
                                label="Netfang"
                                name="email"
                                value={values.email}
                            />
                        </div>
                    </div>
                </div>
                
                <div className="form__actions">
                    <Button type='submit' buttonType="primary" size="lg">Endurstilla lykilorð</Button>
                </div>
            </div>
            <div className='contactResponse'>
                {response}
            </div>
        </Form>
    );

    return (
        <div className={'KCL_lost_password-form'}>
            <Formik
                initialValues={{
                    email: ''
                }}
                validationSchema={Yup.object({
                    email: Yup.string()
                        .email('Ógilt netfang')
                        .required('Netfang verður að fylgja'),
                })}
                onSubmit={handleSubmit}
                component={FormComponent}
            />
        </div>
    );
}

export default LostPasswordForm;